import { ShieldCheck } from "lucide-react";

/** "Your membership just saved you $X" box for confirmation screens. Renders nothing for non-members. */
export function MemberSavings({ tierName, saved, savedMonth }) {
  const s = Number(saved || 0);
  if (s <= 0) return null;
  const m = Number(savedMonth || 0);
  return (
    <div className="mt-5 rounded-xl border border-[#FFD600]/40 bg-[#FFD600]/10 px-4 py-3 text-sm text-left flex items-start gap-3" data-testid="member-savings">
      <ShieldCheck className="w-5 h-5 text-[#FFD600] shrink-0 mt-0.5" />
      <div>
        <div className="font-semibold text-[#FFD600]" data-testid="member-savings-session">Your {tierName || "membership"} just saved you ${s.toFixed(2)} on this session.</div>
        {m > s + 0.005 && <div className="text-slate-200 mt-0.5" data-testid="member-savings-month">That's ${m.toFixed(2)} saved so far this month.</div>}
      </div>
    </div>
  );
}
